<template>
    <div>
        <router-link class="board-card" :to="{ name: 'home' }">
            <h3>Mis Paneles</h3>
        </router-link>
        <div class="boards-collection">
            <span v-if="fetchingData">Cargando...</span>
            <div v-if="!fetchingData" class="input-container">


            </div>
            <v-text-field v-if="!fetchingData" class="input-box board-input" type="text" placeholder="   +  Añade un nuevo panel"
                v-model="boardName" @keydown.enter.prevent="add()"></v-text-field>



            <board-card v-if="!fetchingData" v-for="(board, index) in boards" :key="'board-' + index" :name="board.name"
                :id="board.id">
            </board-card>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import BoardCard from '@/components/BoardCard'

export default {
    name: 'home',
    components: { BoardCard },
    data() {
        return {
            boardName: '',
        }
    },
    computed: {
        ...mapState(['boards', 'fetchingData'])
    },
    methods: {
        ...mapActions(['fetchBoards', 'addBoard']),
        add() {
            this.addBoard({ name: this.boardName })
            this.boardName = ''
        },
    },
    created() {
        this.fetchBoards({ user: 1 })
    },
}
</script>
<style lang="scss" scoped>
.board-card {
    text-decoration: none;
    color: #37474f;

    &:hover {
        color: #90a4ae;
        font-weight: bold;
    }
}


h3 {
    text-align: left;
    margin: 1.5rem;

}

.boards-collection {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    padding-top: 0.8rem;
}

.input-box {
    box-sizing: border-box;
    background-color: #6daf8b;
    border: 2px solid #6daf8b;
    border-radius: 5px;
    font-size: 1.1rem;
    outline: 0;
    padding: 0.4rem;
    transition: all 600ms ease;
    margin: 0.5rem 0.8rem;

    &:focus,
    &:active {
        background-color: white;
        color: #546E7A;


    }


    &::placeholder {
        color: white;
    }



    @media screen and (min-width: 600px) {
        width: 33%;
    }

    @media screen and (min-width: 1024px) {
        width: 250px;
    }
}
</style>